<template>
    <div v-if="isShow" :style="domStyle">
        <!-- 请在此添加代码 -->
        <img @click="upData" src="./img/updata.png" style="position:absolute;width:32px;height:32px;right:1px;bottom:1px;"/>
        <iframe ref="iframeDiv" :src="url" scrolling="auto" frameborder="0" style="width:100%;height:100%"></iframe>
        <img v-if="isNoTemplate" src="./img/noTemplate.jpg" :style="enableStyle"/>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        this.upDataTemplate();
        console.log(this.url);
    },
    data : function(){
        return {
            isNoTemplate : false,
            url : "",
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            // 版本号
            version: "10.0.3.1"
        }
    },
    methods : {
        upDataTemplate(templateName){
            if(templateName){
                this.templateName = templateName;
            }
            if(this.templateName == null || this.templateName == undefined || this.templateName == ""){
                this.$Message.error("模板名称不能为空");
                this.isNoTemplate = true;
                return;
            }
            this.isNoTemplate = false;
            this.upData();
        },
        upData(){
            this.url = "";
            this.url = "/ExcelTemplate/" + this.sourceName + "/" + this.templateName + "/" + this.templateName + ".htm";
        },
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){

        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvExccelTemplate/fvExccelTemplate.vue